import React from 'react'
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import EnvokePermission from '../../components/EnvokePermissionForm/EnvokePermission';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const Permissions = ({ open, onClose , user}) => {
    console.log("🚀 ~ Permissions ~ user:", user)
    
      
      const theme = useTheme();
  return (
    <>
     <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      
        maxWidth="md"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "10vh",
          borderRadius: "16px",
          
          paddingInline: "20px",
          border: "2px solid #ccc",
          overflow: "auto",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          
        position: "absolute",
        top: 10,
        right: 10,
          
        }}
      >
        <CloseIcon />
      </IconButton>
        <EnvokePermission   user={user} />
    </Dialog>
      </>
  );
}

export default Permissions